module.exports = __webpack_public_path__ + "img/why-ico6.a566f37c.png";